import { Box } from "@mui/material";
import TopSection from "../LT/TopSection";
import ForecastExtractionScheduleTab from "./ForecastExtractionScheduleTab";

const ForecastExtractionSchedulePage = () => {
  return (
    <Box sx={{ px: 2, pt: 0, pb: 4 }}>
      <TopSection
        labelList={[
          { title: "Home", path: "/forecastCollabPage" },
          { title: "Forecast Extraction Calendar" },
        ]}
        tabTitle="Forecast Extraction Calendar"
        hideTitle
      />
      <ForecastExtractionScheduleTab />
    </Box>
  );
};

export default ForecastExtractionSchedulePage;
